export const GET_MESSAGES_ACTION = "chat/getMessages";
export const ADD_MESSAGE_ACTION = "chat/createMessage";
export const EDIT_MESSAGE_ACTION = "chat/editMessage";
export const REMOVE_MESSAGE_ACTION = "chat/removeMessage";
export const RESTORE_MESSAGE_ACTION = "chat/restoreMessage";

